module.exports = __webpack_public_path__ + "static/legala_logo-01e588e8b32be5d66faeeebbaecaa73a.png";